export enum ERateValues {
  TooLow = 'too_low',
  Low = 'low',
  Agreed = 'agreed',
  High = 'high',
  TooHigh = 'too_high',
}

export enum ERateScreen {
  Form = 'form',
  Thanks = 'thanks',
}

export interface IRateOurEstimationState {
  screen: ERateScreen;
  isScoreFact: boolean;
  isOpen: boolean;
  userPrice?: number;
  comment?: string;
  rateOurEstimationValue?: ERateValues;
  isLoading?: boolean;
  isLoadingBlock?: boolean;
}
